import React from "react";
import PropTypes from "prop-types";
import ChrBand from "../../../../models/ChrBand";

function Band({ height, zoomRegion, band, start, end, clipPath }) {
  const { chromosome, x0, x1 } = band?.region || {};
  const { name: chrName } = chromosome;
  const tooltipTxt = `
      <div class="tw-text-2xs tw-p-0.5">
        <div>
          <span class="tw-font-bold tw-uppercase">${band.band}</span>
          <span class="tw-px-1">[${band.stain}]</span>
        </div>
        <div class="tw-h-2"></div>
        <div class="tw-py"><span class="tw-w-12 tw-inline-block">Start:</span> ${chrName}: ${x0.toLocaleString()}</div>
        <div class="tw-py"><span class="tw-w-12 tw-inline-block">End:</span> ${chrName}: ${x1.toLocaleString()}</div>
      </div>
    `;

  return (
    <rect
      className={`band tw-pointer-events-auto ${band.stain}`}
      opacity={band.opacity}
      height={height}
      title={band.band}
      data-tooltip={tooltipTxt}
      data-tooltip-delay={400}
      data-tooltip-follow-mouse={true}
      data-tooltip-animation="-"
      data-tooltip-dangerous-html="1"
      data-tooltip-class="genome-browser-small-tooltip"
      clipPath={clipPath}
      x={Math.min(start, end)}
      width={Math.abs(start - end)}
      onClick={() => zoomRegion(band.region)}
    />
  );
}

Band.propTypes = {
  clipPath: PropTypes.string.isRequired,
  band: PropTypes.instanceOf(ChrBand).isRequired,
  zoomRegion: PropTypes.func.isRequired,
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default Band;
